module.exports = __webpack_public_path__ + "img/shuju.0c50e111.png";